import React, { useState, useEffect } from 'react';
import './ServiceCenterSidebar.css';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

function SubServiceCenterSideBarTwo({ changeActive, searchtext, setSearchText }) {
  const [active, setActive] = useState("")
  const activeFilter = useSelector((state) => state.serviceCenter.activeFilter)
  useEffect(() => {
    if (activeFilter !== undefined && activeFilter !== null) {
      changeActive(activeFilter)
      setActive(activeFilter)
      changeImgSrcOnMount()
    }
  });

  const history = useHistory();

  const handleComplaintRegistration = () => {
    history.push('/complaint-registration-template')
  }

  const changeImgSrcOnMount = () => {
    let siblings = document.querySelector('.sideBarFilters').childNodes;
    if (activeFilter === 1) {
      siblings[0].firstChild.firstChild.src = siblings[0].firstChild.firstChild.dataset.src;
    }
    if (activeFilter === 2) {
      siblings[1].firstChild.firstChild.src = siblings[1].firstChild.firstChild.dataset.src;
    }
    if (activeFilter === 3) {
      siblings[2].firstChild.firstChild.src = siblings[2].firstChild.firstChild.dataset.src;
    }
    if (activeFilter === 4) {
      document.getElementById('manageUsersIcon').src = '/img/ManageUsersIcon-blue.svg'
    }
  }

  const changeImgSrc = (buttonName) => {
    let siblings = document.querySelector('.sideBarFilters').childNodes;
    for (let i = 0; i < siblings.length; i++) {
      if (siblings[i].innerText === "Active" && siblings[i].innerText !== buttonName) {
        siblings[i].firstChild.firstChild.src = "/img/userLogo.svg"
      }
      if (siblings[i].innerText === 'Replacement' && siblings[i].innerText !== buttonName) {
        siblings[i].firstChild.firstChild.src = '/img/pauseIcon.svg'
      }
      if (siblings[i].innerText === 'Closed' && siblings[i].innerText !== buttonName) {
        siblings[i].firstChild.firstChild.src = '/img/clock.svg'
      }
    }
  }

  const handleIconChange = (e) => {
    setSearchText(false)
    document.getElementById('searchInput').value = '';
    let clickedBtnName = e.target.innerText;
    if (clickedBtnName === 'Active') {
      changeActive(1);
      setActive(1);
      e.target.firstChild.src = e.target.firstChild.dataset.src;
      changeImgSrc(clickedBtnName);
      document.getElementById('manageUsersIcon').src = '/img/ManageUsersIcon.svg'
    } else if (clickedBtnName === 'Replacement') {
      changeActive(2);
      setActive(2);
      e.target.firstChild.src = e.target.firstChild.dataset.src;
      changeImgSrc(clickedBtnName);
      document.getElementById('manageUsersIcon').src = '/img/ManageUsersIcon.svg'
    } else if (clickedBtnName === 'Closed') {
      changeActive(3);
      setActive(3);
      e.target.firstChild.src = e.target.firstChild.dataset.src;
      changeImgSrc(clickedBtnName);
      document.getElementById('manageUsersIcon').src = '/img/ManageUsersIcon.svg'
    } else if (clickedBtnName === 'Manage Users') {
      changeActive(4);
      setActive(4);
      e.target.firstChild.src = e.target.firstChild.dataset.src;
      changeImgSrc(clickedBtnName);
    } else {
      changeActive(1);
      setActive(1);
      changeImgSrc(clickedBtnName);
      document.getElementById('manageUsersIcon').src = '/img/ManageUsersIcon.svg'
    }
  }

  const handleFilterClick = (e) => {
    let clickedBtnName = e.target.innerText
    if (clickedBtnName === 'Active') {
      changeActive(1);
      setActive(1);
      e.target.firstChild.src = e.target.firstChild.dataset.src;
      changeImgSrc(clickedBtnName);
    } else if (clickedBtnName === 'Replacement') {
      changeActive(2);
      setActive(2);
      e.target.firstChild.src = e.target.firstChild.dataset.src;
      changeImgSrc(clickedBtnName);
    } else if (clickedBtnName === 'Closed') {
      changeActive(3);
      setActive(3);
      e.target.firstChild.src = e.target.firstChild.dataset.src;
      changeImgSrc(clickedBtnName);
    } else {
      changeActive(1);
      setActive(1);
      changeImgSrc(clickedBtnName);
    }
  }

  return (
    <div className='serviceCenterSidebar'>
      <h4 className='sideBarHeading'>Complaints</h4>
      {searchtext === true ?
        <ul className='sideBarFilters'>
          <li><a onClick={handleIconChange}><img data-src='/img/userLogo.svg' src='/img/userLogo.svg' alt='User Logo Icon' />Active</a></li>
          <li><a onClick={handleIconChange}><img data-src='/img/pauseIcon.svg' src='/img/pauseIcon.svg' alt=' ' />Replacement</a></li>
          <li><a onClick={handleIconChange}><img id='clockIcon' data-src='/img/clock.svg' src='/img/clock.svg' alt='Clock Icon' />Closed</a></li>
        </ul>
        :
        <ul className='sideBarFilters'>
          <li id={active === 1 ? 'active' : ''}><a onClick={handleFilterClick}><img data-src='/img/userLogo-blue.svg' src='/img/userLogo.svg' alt='User Logo Icon' />Active</a></li>
          <li id={active === 2 ? 'active' : ''}><a onClick={handleFilterClick}><img data-src='/img/pauseIcon-blue.svg' src='/img/pauseIcon.svg' alt=' ' />Replacement</a></li>
          <li id={active === 3 ? 'active' : ''}><a onClick={handleFilterClick}><img id='clockIcon' data-src='/img/clock-blue.svg' src='/img/clock.svg' alt='Clock Icon' />Closed</a></li>
        </ul>
      }
      <button onClick={handleComplaintRegistration} className='sideBarBtn' id='complaintBtn'>
        <i className="fa fa-plus" aria-hidden="true"></i>
        &nbsp;New Complaint
      </button>
    </div>
  )
}

export default SubServiceCenterSideBarTwo;